// eslint-disable-next-line import/prefer-default-export
export function formatDateToLocal(dateString) {
  const d = new Date(dateString)

  return `${(`${d.getDate()}`).padStart(2, '0')}-${(`${d.getMonth() + 1}`).padStart(2, '0')}-${d.getFullYear()}`
}
